"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioInputGroup = exports.radioInputGroupProps = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var filter_input_styles_1 = require("./filter_input.styles");
var immutable_1 = require("immutable");
var radioInputGroupProps = function (filterInput) { return ({
    onChangeValue: function (option) {
        filterInput.setState({
            filter: __assign(__assign({}, filterInput.state.filter), { selected: immutable_1.OrderedSet.of(option) }),
        });
    },
    onClickRemove: function () {
        filterInput.props.setAppliedFilters(filterInput.state.filter.value, immutable_1.OrderedSet.of());
        filterInput.setState({
            filter: { label: '', value: '', options: immutable_1.OrderedSet.of(), selected: immutable_1.OrderedSet.of() },
            isPopoverOpen: false,
        });
    },
    onClickCancel: function () { return filterInput.setState({ isPopoverOpen: false }); },
    onClickApply: function () {
        filterInput.props.setAppliedFilters(filterInput.state.filter.value, filterInput.state.filter.selected);
        filterInput.setState({
            filter: { label: '', value: '', options: immutable_1.OrderedSet.of(), selected: filterInput.state.filter.selected },
            isPopoverOpen: false,
        });
    },
}); };
exports.radioInputGroupProps = radioInputGroupProps;
var RadioInputGroup = function (props) {
    var selected = props.selected, options = props.options, onChangeValue = props.onChangeValue, inputType = props.inputType;
    return (react_1.default.createElement(storm_ui_1.UIDConsumer, { value: 'select-filter' }, function (uid) {
        var _a, _b;
        return (react_1.default.createElement(filter_input_styles_1.PaddedRadioGroup, { id: uid, label: '', name: 'select-filter', selectedValue: (_b = (_a = selected.toArray()) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.value, onChange: function (newValue) {
                return onChangeValue(options.find(function (option) { return option.value === newValue; }), inputType);
            } }, options
            .map(function (option) {
            return react_1.default.createElement(storm_ui_1.RadioButton, { id: "uid-".concat(option.value), key: option.value, label: react_1.default.createElement(storm_ui_1.Text, null, option.label), value: option.value });
        })
            .toArray()));
    }));
};
exports.RadioInputGroup = RadioInputGroup;
